import React from 'react';
import TasksPage from '../tasks/TasksPage';
import ReportLayout from './ReportLayout';

export default function TasksReportPage() {
  return (
    <ReportLayout
      badge="Weekly Reporting"
      title="My Tasks Report"
      description="This report consolidates your weekly task records, progress status, achievements, and reported challenges."
    >
      <TasksPage />
    </ReportLayout>
  );
}
